/**
 * Distinguishes gallery (`album`) uploads from explicit event hero/cover (`cover`) assets.
 * Persisted on `Media.purpose`; required on image uploads when `eventId` is present.
 */

export const EVENT_MEDIA_PURPOSE_ALBUM = "album" as const
export const EVENT_MEDIA_PURPOSE_COVER = "cover" as const

export type EventMediaPurpose =
  | typeof EVENT_MEDIA_PURPOSE_ALBUM
  | typeof EVENT_MEDIA_PURPOSE_COVER

const PURPOSES = new Set<string>([
  EVENT_MEDIA_PURPOSE_ALBUM,
  EVENT_MEDIA_PURPOSE_COVER,
])

export function isEventMediaPurpose(v: string): v is EventMediaPurpose {
  return PURPOSES.has(v)
}

/** Album grid and shared gallery: everything except explicit cover rows. */
export function isAlbumGalleryPurpose(
  purpose: string | null | undefined,
): boolean {
  const p = purpose?.trim().toLowerCase() ?? ""
  return p !== EVENT_MEDIA_PURPOSE_COVER
}

export function parseEventImageUploadPurpose(
  raw: unknown,
): EventMediaPurpose | null {
  if (raw == null) return null
  if (typeof raw !== "string") return null
  const t = raw.trim().toLowerCase()
  if (!isEventMediaPurpose(t)) return null
  return t
}
